import React from 'react';
import { AlertTriangle } from 'lucide-react';
interface UrgencyBarProps {
  spotsLeft: number;
}
export function UrgencyBar({
  spotsLeft
}: UrgencyBarProps) {
  return <div role="status" className="fixed inset-x-0 top-0 z-50 border-b border-signal-pink/70 bg-[linear-gradient(90deg,#1a0510,#0a0a12_45%,#051417)] shadow-[0_0_26px_rgba(255,47,146,0.25)]" data-id="element-251" data-mp="3ctbmyo62adhc">
      <div className="mx-auto flex h-[44px] max-w-[1200px] items-center justify-center gap-2 overflow-hidden px-3 text-center sm:h-[52px] sm:gap-2.5 sm:px-4" data-id="element-252" data-mp="2yveuo3yn4t8h">
        <span aria-hidden="true" className="h-1.5 w-1.5 flex-shrink-0 animate-blip rounded-full bg-signal-pink shadow-[0_0_8px_#ff2f92,0_0_16px_#00e5ff]" data-id="element-253" data-mp="2u33pall4sf8j" />
        <AlertTriangle aria-hidden="true" className="hidden h-3.5 w-3.5 flex-shrink-0 text-signal-pink sm:block" data-id="element-254" data-mp="2k7to202k4bvt" />
        <p className="line-clamp-2 text-[10px] font-semibold leading-snug text-bone sm:text-[11.5px]" data-id="element-255" data-mp="2f98rcamikac4">
          <span className="hidden sm:inline" data-id="element-256" data-mp="1rxat76kx9pkr">ATENCIÓN: </span>El acceso de{' '}
          <span className="bg-[linear-gradient(90deg,#ff2f92,#00e5ff)] bg-clip-text font-extrabold text-transparent" data-id="element-257" data-mp="1rv7t1tq22g2b">
            $11.99
          </span>{' '}
          es una prueba de mercado
          <span className="hidden sm:inline" data-id="element-258" data-mp="1i0xyc5dn55of">
            {' '}
            para los primeros 500 clientes
          </span>
          . Después sube a $47. Quedan{' '}
          <span className="bg-[linear-gradient(90deg,#ff2f92,#00e5ff)] bg-clip-text font-extrabold text-transparent" data-id="element-259" data-mp="2aotwleiuz5nb">
            {spotsLeft} cupos
          </span>
          .
        </p>
      </div>
    </div>;
}